import _ from "lodash";
import {addEditDPActionTypes} from "../constants/AddEditActionConstants";

const initialState = {
    addNewDP: false,
    editDP: false,
    modalOpenDP: false,
    editModalOpenDP: false,
    updatedDP: false,
    dpModalHeader: "",
    providerObject: {
        provider_detail: {
            provider_id: "",
            provider_name: "",
            monthly_aggregate_volume: null,
        },
        approvals: {
            id: "",
            resource_id: "",
            is_approved: false,
            approved_on: null,
            approved_by: ""
        },
        contact_information: [
            {
                id: null,
                resource_id: "",
                type: "Business",
                name: "",
                email: "",
                phone_number: ""
            },
            {
                id: null,
                resource_id: "",
                type: "Technical",
                name: "",
                email: "",
                phone_number: "",
            },
        ]
    },
}


const addEditDPReducer = (state = initialState, action) => {
    switch (action.type) {

        case addEditDPActionTypes.CREATE_DP_MODAL: {
            let newState = _.cloneDeep(state);
            newState.addNewDP = true;
            newState.modalOpenDP = true;
            newState.dpModalHeader = "Add a new Data Provider"
            return newState;
        }

        case addEditDPActionTypes.EDIT_DP_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editModalOpenDP = true;
            newState.providerObject = action.payload.detailObject;
            newState.dpModalHeader = "Edit Data Provider - " + newState.providerObject.provider_detail.provider_name;
            return newState;
        }

        case addEditDPActionTypes.CLOSE_DP_MODAL: {
            return initialState;
        }

        case addEditDPActionTypes.SETTING_DP_FORM_OBJECT_VALUE: {
            let newState = _.cloneDeep(state);
            newState.providerObject[action.payload.change_obj][action.payload.name] = action.payload.value;
            return newState;
        }

        case addEditDPActionTypes.UPDATE_DP_CONTACT: {
            let newState = _.cloneDeep(state);
            newState.providerObject.contact_information.forEach(contact => {
                if (contact.type === action.payload.name) {
                    contact[action.payload.change_obj] = action.payload.value
                }
            });
            return newState;

        }

        case addEditDPActionTypes.UPDATED_DP_REFRESH: {
            let newState = _.cloneDeep(state);
            newState.updatedDP = !newState.updatedDP;
            return newState;
        }


        default:
            return state;
    }
}

export default addEditDPReducer;
